import React from 'react';
import { PropTypes } from 'prop-types';
import { Link } from 'react-router';
import { MotifIcon } from '@ey-xd/motif-react';
import { IconoirHelpCircle } from '@ey-xd/motif-icon';

const DataStewardRoleManagementHeader = ({ displayDataSteward }) => {
  return (
    <div className="row">
      <div className="col-md-12">
        {displayDataSteward ? (
          <h2 data-testid="pghdrAuthorizedUsers" id="information">
            Authorized Users
            <Link to={'/helpGuide/'} target="_blank" rel="noopener noreferrer">
              <MotifIcon
                className="ml-2 mt-2 mr-5 dataretentionIcon"
                iconFunction={IconoirHelpCircle}
                size="24"
              />
            </Link>
          </h2>
        ) : (
          <h2 data-testid="pghdrAuthorizedUsers">Authorized Users</h2>
        )}
        {displayDataSteward && (
          <p className="text-danger" id="informationText">
            The Data Deletion Policy for REITSuite instructs that at least one
            authorized user must be designated as a Data Steward to proceed with
            further access to the application. For more information, please
            click on the help icon.
          </p>
        )}
      </div>
    </div>
  );
};

DataStewardRoleManagementHeader.propTypes = {
  displayDataSteward: PropTypes.bool,
};

export default DataStewardRoleManagementHeader;
